import { Component, HostListener, OnInit } from '@angular/core';
import { HxAuthService, PermissionKey } from 'hx-services';
import { IsActiveMatchOptions, RouterLink, RouterLinkActive } from '@angular/router';
import { NgFor, NgIf } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';
import { buildMainMenu, MenuItem } from './main-menu';


const EXPANDED_GROUPS_KEY = 'cc.sidebar.expanded-groups';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css'],
    imports: [NgFor, NgIf, RouterLinkActive, RouterLink, TranslocoPipe]
})
export class SidebarComponent implements OnInit {
  profileUrl = `${location.protocol}//profile.${location.hostname.split('.').slice(1).join('.')}`;
  mainmenu: MenuItem[] = buildMainMenu();
  expandedGroups: Record<string, boolean> = readExpandedGroups();
  // Пункт активен по пути, query-параметры не в счёт: иначе подсветка пропадает на /faq?faq_id=…,
  // на страницах с фильтрами в адресе (calls-new, feedbacks-new) и на «Заказах» после смены фильтра.
  // Пути у пунктов меню не повторяются, так что двух активных сразу не бывает.
  activeOptions: IsActiveMatchOptions = {paths: 'exact', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored'};

  constructor(
    private auth: HxAuthService,
  ) {
  }

  public menu = {
    settings: {
      click: true
    }
  };

  ngOnInit() {
    let permissions: PermissionKey[] = [];
    this.mainmenu.filter(r => r.permissions && r.permissions.length > 0).forEach(p => {
      p.permissions?.forEach(t => permissions.push(t));
    });
    this.auth.getPermissions({permissions: [...new Set(permissions)] }).subscribe(result => {
      if (result && result.length > 0) {
        this.mainmenu.filter(r => r.permissions && r.permissions.length > 0).forEach(m => {
          const filteredArray = m.permissions?.filter(v => result.map(r => r.key).includes(v)) ?? [];
          if (filteredArray.length > 0) {
            m.visible = true;
          }
        });
      }
    });
  }

  @HostListener('document:click', ['$event'])
  handleClickEvent(event: Event) {
    const body = document.getElementsByTagName('body')[0];
    const hasClass = body.className.indexOf('--on');

    if (hasClass !== -1 && (event.target as any).className.indexOf('open-sidebar') === -1) {
      this.toggleMobSidebar();
    }
  }

  toggleMobSidebar() {
    const body = document.getElementsByTagName('body')[0];
    const hasClass = body.className.indexOf('--on');

    if (hasClass !== -1) {
      body.classList.remove('m-aside-left--on');
    } else {
      body.classList.add('m-aside-left--on');
    }
  }

  toggleGroup(group: string, event: Event) {
    // иначе document:click закроет мобильный сайдбар, не дав увидеть раскрытый раздел
    event.stopPropagation();
    this.expandedGroups = {...this.expandedGroups, [group]: !this.expandedGroups[group]};
    try {
      localStorage.setItem(EXPANDED_GROUPS_KEY, JSON.stringify(this.expandedGroups));
    } catch {
      // без localStorage раздел просто снова свернётся после перезагрузки
    }
  }

  routerLink(item: MenuItem): string {
    if (item.link) {
      return `/${item.link}`;
    }
    return `/${item.title}`;
  }
}

function readExpandedGroups(): Record<string, boolean> {
  try {
    return JSON.parse(localStorage.getItem(EXPANDED_GROUPS_KEY) ?? '{}') ?? {};
  } catch {
    return {};
  }
}
